import { Receipt } from "@mui/icons-material"

const baseUri = ""
const urls = {
  root: baseUri,
  auth: {
    login: `${baseUri}/login`,
    logout: `${baseUri}/logout`,
  },
  admin: {
    payments: {
      root: (hotelSlug) => `${baseUri}/${hotelSlug}/payments`,
    },
    reports: {
      root:(hotelSlug)=> `${baseUri}/${hotelSlug}/reports`,
      categorysales:(hotelSlug)=> `${baseUri}/${hotelSlug}/reports/categorysales`,
      customerrating:(hotelSlug)=> `${baseUri}/${hotelSlug}/reports/customerrating`,
      newcustomer:(hotelSlug)=> `${baseUri}/${hotelSlug}/reports/newcustomer`,
      repeatcustomer:(hotelSlug)=> `${baseUri}/${hotelSlug}/reports/repeatcustomer`,
      orderhistory:(hotelSlug)=> `${baseUri}/${hotelSlug}/reports/orderhistory`,
    },
    floors: {
      root: (hotelSlug) => `${baseUri}/${hotelSlug}/floors`,
      list: (hotelSlug) => `${baseUri}/${hotelSlug}/floors`,
      create: (hotelSlug) => `${baseUri}/${hotelSlug}/floors/create`,
      show: (hotelSlug, floor, id) => `${baseUri}/${hotelSlug}/floors/${floor}/${id}`,
      update: (hotelSlug, floorName, id) => `${baseUri}/${hotelSlug}/floors/edit/${floorName}/${id}`,
      createTable: (hotelSlug,floor_no, id) => `${baseUri}/${hotelSlug}/floors/create-table/${floor_no}/${id}`,
      updateTable: (hotelSlug,floorSlug,tableSlug,floor_id) => `${baseUri}/${hotelSlug}/floors/${floorSlug}/${floor_id}/edit/${tableSlug}`,
    },

    
    halls: {
      root: (hotelSlug) => `${baseUri}/${hotelSlug}/halls`,
      list: (hotelSlug) => `${baseUri}/${hotelSlug}/halls`,
      create: (hotelSlug) => `${baseUri}/${hotelSlug}/halls/create`,
      show: (floor, id) => `${baseUri}/floors/${floor}/${id}`,
      update: (hotelSlug, hallSlug, id) => `${baseUri}/${hotelSlug}/halls-${hallSlug}/${id}`,
      createTable: (floor_no, id) => `${baseUri}/floors/create-table/${floor_no}/${id}`,
      updateTable: (floor_id, table_id) => `${baseUri}/floors/${floor_id}/edit/table/${table_id}`,
    },
    menu: {
      // root:(hotelSlug)=> `${baseUri}/menu/${hotelSlug}`,
      root: (hotelSlug) => `${baseUri}/${hotelSlug}/menu`,
      list: `${baseUri}/menu`,
      create: (hotelSlug) => `${baseUri}/${hotelSlug}/menu/create`,
      show: (id) => `${baseUri}/menu/${id}`,
      update: (hotelSlug, categorySlug, menuSlug,id) =>
        `${baseUri}/${hotelSlug}/menu/${categorySlug}/${menuSlug}/${id}`,
    },
    bookings: {
      root: (hotelSlug) => `${baseUri}/${hotelSlug}/bookings`,
      list: (hotelSlug) => `${baseUri}/${hotelSlug}/bookings`,
      show: (id) => `${baseUri}/bookings/${id}`,
      update: (id) => `${baseUri}/bookings/edit/${id}`,
    },
    dashboard: {
      root: (hotelSlug) => `${baseUri}/${hotelSlug}/dashboard`,
      analytics: (hotelSlug) => `${baseUri}/${hotelSlug}/dashboard/analytics`,
    },
    orders: {
      root: (hotelSlug) => `${baseUri}/${hotelSlug}/orders`,
      list: (hotelSlug) => `${baseUri}/${hotelSlug}/pickupOrders`,
      show: (hotelSlug, orderType, id) => `${baseUri}/${hotelSlug}/orders-${orderType}/${id}`,
      history: (hotelSlug) => `${baseUri}/${hotelSlug}/order-history`,
    },
    kot: {
      root: (hotelSlug) => `${baseUri}/${hotelSlug}/kot`,
    },
    category: {
      root: (hotelSlug) => `${baseUri}/${hotelSlug}/categories`,
      create: (hotelSlug) => `${baseUri}/${hotelSlug}/categories/create`,
      show: (hotelSlug, categorySlug, id) => `${baseUri}/${hotelSlug}/categories-${categorySlug}/${id}`,
      update: (hotelSlug, slug, id) => `${baseUri}/${hotelSlug}/categories/edit/${slug}/${id}`,
    },
    // coupons: { root: `${baseUri}/coupons` },
    hotels: {
      root: `${baseUri}/hotel`,
      list: `${baseUri}/hotel`,
      create: `${baseUri}/hotel/new`,
      show: `${baseUri}/hotel/profile`,
      update: `${baseUri}/hotel/update-profile`,
      delete: (id) => `${baseUri}/hotel/${id}`,
    },
    root: `${baseUri}`,
    users: {
      root: (hotelSlug) => `${baseUri}/${hotelSlug}/staff-login`,
      list: (hotelSlug) => `${baseUri}/${hotelSlug}/users`,
      create: (hotelSlug) => `${baseUri}/${hotelSlug}/staff-login/create`,
      show: (id) => `${baseUri}/users/${id}`,
      update: (hotelSlug, staffSlug, id, action = "") =>
        `${baseUri}/${hotelSlug}/staff-login/${staffSlug}/${id}/${action}`,
    },
    subscription: {
      root: `${baseUri}/subscription`,
    },
    digitalToken: {
      root: (hotelSlug) => `${baseUri}/${hotelSlug}/digital-token`,
    },
    offers: { root: `${baseUri}/offers` },
    testimonials: { root: `${baseUri}/testimonials` },
    faqs: { root: `${baseUri}/faqs` },
    contact: { root: `${baseUri}/contact` },
    about: { root: `${baseUri}/about` },
    settings: {
      root: `${baseUri}/settings`,
      // timing: `${baseUri}/settings/timing`,
      status: `${baseUri}/settings/status`,
      subscription: `${baseUri}/settings/subscription`,
      profile: `${baseUri}/settings/profile`,
      digitalToken: `${baseUri}/settings/digital-token`,
      // tokenAmount: `${baseUri}/settings/token-amount`,
      // gallery: `${baseUri}/settings/gallery`,
      // reviews: `${baseUri}/settings/reviews`,
      allusers: `${baseUri}/settings/allusers`,
      // customerDetail :(hotelSlug)=>`${baseUri}/settings/${hotelSlug}/customerDetail`,
      loginInfo: `${baseUri}/settings/loginInfo`,
      // coupon: `${baseUri}/settings/coupon`,
    },
    loginInfo: {
      root: (hotelSlug, userName) => `${baseUri}/${hotelSlug}/loginInfo/${userName}`,
    },
    profile: {
      root: (hotelSlug) => `${baseUri}/${hotelSlug}/profile`,
    },
    subscriptions: {
      root: (hotelSlug) => `${baseUri}/${hotelSlug}/active-subscription`, // Make this a function
      // Add other subscription-related routes if needed
    },
    tokenAmounts: {
      root: (hotelSlug) => `${baseUri}/${hotelSlug}/token-amount`,
    },
    gallery: {
      root: (hotelSlug) => `${baseUri}/${hotelSlug}/gallery`,
    },
    qrCode: {
      root: (hotelSlug) => `${baseUri}/${hotelSlug}/qr-code`,
    },
    status: { 
      root: (hotelSlug) => `${baseUri}/${hotelSlug}/status`,
    },
    timing: {
      root: (hotelSlug) => `${baseUri}/${hotelSlug}/timing`,
    },
    customers: {
            view: (hotelSlug, customerSlug) => `${baseUri}/${hotelSlug}/customer/${customerSlug}`, // Corrected path

      root: (hotelSlug) => `${baseUri}/${hotelSlug}/customer`,
    },
    review: {
      root: (hotelSlug) => `${baseUri}/${hotelSlug}/reviews`,
    },
    hotelusers: {
      root: `${baseUri}/hotelusers`,
      // update: (id) => `${baseUri}/inventory/view/${id}`,
    },    

    inventory: {
      root: `${baseUri}/inventory`,
      list: `${baseUri}/inventory`,
      create: (hotelSlug) => `${baseUri}/inventory/${hotelSlug}/create`,
      update: (id) => `${baseUri}/inventory/edit/${id}`,
    },
    supplier: {
      root: `${baseUri}/supplier`,
      list: `${baseUri}/supplier`,
      create: `${baseUri}/supplier/create`,
      update: (id) => `${baseUri}/supplier/edit/${id}`,
    },
    coupon: {
      root: (hotelSlug) => `${baseUri}/${hotelSlug}/coupon`,
      list: `${baseUri}/coupon`,
      create: (hotelSlug) => `${baseUri}/${hotelSlug}/coupon/create`,
      update: (hotelSlug, couponCode, id) => `${baseUri}/${hotelSlug}/coupon-${couponCode}/${id}`,
    },
    integrations: {
      root: (hotelSlug) => `${baseUri}/${hotelSlug}/integrations`,
      list: `${baseUri}/integrations`,
      create: `${baseUri}/integrations/create`,
      update: (id) => `${baseUri}/integrations/edit/${id}`,
      listgateways: `${baseUri}/listgateways`,
    },
    outlate: {
      root: `${baseUri}/outlate`,
      list: `${baseUri}/outlate`,
      create: `${baseUri}/outlate/create`,
      update: (id) => `${baseUri}/outlate/edit/${id}`,
    },
    outlet: {
      root: `${baseUri}/outlet`,
      list: `${baseUri}/outlet/list`,
      create: `${baseUri}/outlet/create`,
      update: (id) => `${baseUri}/outlet/edit/${id}`,
      receipt: `${baseUri}/outlet/receipt`,

    },
    customBilling: {
      root: `${baseUri}/custom-billing`,
      list: `${baseUri}/custom-billing`,
      create: `${baseUri}/custom-billing/create`,
      dineIn: (hotelSlug) => `${baseUri}/${hotelSlug}/dine-in`,
      orderhistory: `${baseUri}/reports/orderhistory`,
    },
    support: {
      root: (hotelSlug) => `${baseUri}/${hotelSlug}/support`,
      list: `${baseUri}/support`,
      create: (hotelSlug) => `${baseUri}/${hotelSlug}/support/create`,
      detail: (hotelSlug,id) => `${baseUri}/${hotelSlug}/support/${id}`,
    },
    employees: {
      root: (hotelSlug) => `${baseUri}/${hotelSlug}/employees`,
      list: `${baseUri}/employees`,
      create: (hotelSlug) => `${baseUri}/${hotelSlug}/employees/create`,
      show: (id) => `${baseUri}/employees/${id}`,
      update: (hotelSlug, userSlug, id) => `${baseUri}/${hotelSlug}/employees-${userSlug}/${id}`,
    },
    dinein: {
      root: `${baseUri}/dinein`,
    },
  },
}
//function to check is passed url present in nested urls object
export default urls
